import { useState } from 'react';
import BizInput from '../../Mini/BizInput';
import { FormFieldComponentProps } from './fieldProps';

const COMMON_COUNTRY_CODES = [
	{ code: '+46', name: 'Sweden', flag: '🇸🇪' },
	{ code: '+47', name: 'Norway', flag: '🇳🇴' },
	{ code: '+45', name: 'Denmark', flag: '🇩🇰' },
	{ code: '+358', name: 'Finland', flag: '🇫🇮' },
	{ code: '+1', name: 'USA', flag: '🇺🇸' },
	{ code: '+44', name: 'UK', flag: '🇬🇧' },
	{ code: '+49', name: 'Germany', flag: '🇩🇪' },
	{ code: '+33', name: 'France', flag: '🇫🇷' },
	{ code: '+34', name: 'Spain', flag: '🇪🇸' },
	{ code: '+39', name: 'Italy', flag: '🇮🇹' },
	{ code: '+31', name: 'Netherlands', flag: '🇳🇱' },
	{ code: '+32', name: 'Belgium', flag: '🇧🇪' },
	{ code: '+41', name: 'Switzerland', flag: '🇨🇭' },
	{ code: '+43', name: 'Austria', flag: '🇦🇹' },
	{ code: '+48', name: 'Poland', flag: '🇵🇱' },
];

const PhoneCountryCodeField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const [countryCode, setCountryCode] = useState('+46');

	const phoneWithoutCode = value.startsWith(countryCode) ? value.slice(countryCode.length) : value;

	const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const newCode = e.target.value;
		setCountryCode(newCode);
		onChange(newCode + phoneWithoutCode);
	};

	const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(countryCode + e.target.value);
	};

	return (
		<div onBlur={onBlur}>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<div className='biz-form-field__phone-row'>
				<select
					className='biz-form-field__phone-country'
					value={countryCode}
					onChange={handleCountryChange}
					disabled={disabled}
				>
					{COMMON_COUNTRY_CODES.map((c) => (
						<option key={c.code} value={c.code}>
							{c.flag} {c.code}
						</option>
					))}
				</select>
				<BizInput
					value={phoneWithoutCode}
					onChange={handlePhoneChange}
					placeholder={field.placeholder}
					readonly={disabled}
					type='tel'
				/>
			</div>
		</div>
	);
};

export default PhoneCountryCodeField;
